import { Card } from 'react-toolbox/lib/card'
import T from 'i18n-react'
import { Flex, Box } from 'reflexbox'

import Actions from './Actions'
import {
  default as Collapse,
} from 'components/fulcrum/collapse/Collapse'
import CardLoading from 'components/display/CardLoading'
import CardHeader from 'components/custom/Card/CardHeader'
import Spreadsheet from 'components/fulcrum/spreadsheet/index'
import FulcrumDivider from 'components/fulcrum/divider/Divider'

import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, nest } from 'recompose'
import { connect } from 'react-redux'
import injectSagas from 'helpers/injectSagas'
import _ from 'lodash'

import Section from 'components/custom/Section/Section'
import {
  withEditHandlers
} from 'components/custom/EditIconButton/index'
import { withCollapse } from 'components/fulcrum/collapse/Collapse'
import {
  MODULE_NAME,
  FORMATTING_RANGES
} from './constants'
import {
  editModeSelector, isCreatingPartSelector, isLoadingSelector, lastUpdatedSelector
} from './selectors'
import {
  updateEditValue,
} from './actions'

import styles from './styles.scss'


const mapStateToProps = (state) => {
    return {
      editMode: editModeSelector(state),
      lastUpdated: lastUpdatedSelector(state),
      isLoading: isLoadingSelector(state),
      isCreatingPart: isCreatingPartSelector(state)
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      toggleEditMode: (key, value) => dispatch(updateEditValue(key, value)),
    }
  }
  

const SectionCard = (props) => {
  
  const lastUpdatedText = (date) => {
    const message = 'Last updated on ' + date
    return (
      <div className={styles.lastUpdated}> {message} </div>
    )
  }

  const onSubmit = (partName, partData, partSettingName) => {
    const {
      editMode,
      postParts,
    } = props
    if (editMode) postParts(partName, partData, partSettingName)
  }

  const genFormattingRanges = () => {
    const { partName } = props
    const formattingRange = FORMATTING_RANGES[partName]
    return formattingRange ? formattingRange : FORMATTING_RANGES.default
  }

  const isArray2D = (array) => {
    return array.every(item => Array.isArray(item))
  } 

  const transpose = (array) => {
    const transposeFunc2D = array => array[0].map((_, colIndex) => array.map(row => row[colIndex]));
    if (isArray2D(array)) return transposeFunc2D(array)
    else return transposeFunc2D([array])
  }

  const replaceColumns = (oldCols, newCols) => {
    const oldColsTransposed = transpose(oldCols)
    const newColsTransposed = transpose(newCols)
    const colHeaders = oldCols[0]
    newColsTransposed.forEach((row) => {
      const colIndex = colHeaders.indexOf(row[0]) 
      oldColsTransposed[colIndex] = row
    })
    return transpose(oldColsTransposed)
  }

  const panelSettingsCardRenderer = () => {
    const { 
      partName,
      partData,
      editMode,
      lastUpdated,
      isLoading,
      isCreatingPart,
      toggleEditMode,
    } = props

    const partDataTransposed = transpose(partData)
    const resolutionIndices = []
    partDataTransposed.forEach((row, index) => {
      const settingName = row[0].toLowerCase().split(' ').join('_')
      if (T.translate(`containers.admin.partsLibrary.${partName}.settings.${settingName}`) === 'Resolutions')
        resolutionIndices.push(index)
    })
    const resolutionDataTransposed = [_.pullAt(partDataTransposed, resolutionIndices)]

    const panelCards = resolutionDataTransposed.concat(partDataTransposed).map((rows, index) => {
      const settingData = transpose(rows)
      const settingKey = settingData[0][0].toLowerCase().split(' ').join('_')
      return (
        <Box w={0.25} px={2} key={index}>
          <Card theme={styles} key={index}>
            <CardHeader>
              <h5>{T.translate(`containers.admin.partsLibrary.${partName}.settings.${settingKey}`)}</h5>
              <Actions
                isCollapsible={false}
                editMode={editMode ? editMode[settingKey] : false}
                toggleEditMode={(value) => toggleEditMode(settingKey, value)}
                onSubmit={() => onSubmit(partName, replaceColumns(partData, settingData), settingKey)}
                isLoading={isLoading || (settingKey in isCreatingPart && isCreatingPart[settingKey])}
              />
            </CardHeader>
            <Spreadsheet 
              list={settingData}
              editMode={editMode[settingKey]}
              formattingRanges={genFormattingRanges()}
              isLoading={isLoading || (settingKey in isCreatingPart && isCreatingPart[settingKey])}
              filters={true}
            />
          </Card>
        </Box>
      )
    })

    return (
      <Fragment>
        {!isLoading && <CardHeader title={T.translate(`containers.admin.partsLibrary.${partName}.title`)}></CardHeader>}
        {lastUpdatedText(lastUpdated[partName])}
        <FulcrumDivider styleName='divider'/>
        <Flex mx={-2}> 
          {panelCards}
        </Flex>
      </Fragment>
    )
  }

  const defaultCardRenderer = () => {
    const { 
      partName,
      partData,
      collapse,
      toggleCollapse,
      editMode,
      lastUpdated,
      isLoading,
      isCreatingPart,
      toggleEditMode,
    } = props
    return (
      <Fragment>
        <CardHeader title={T.translate(`containers.admin.partsLibrary.${partName}.title`)}>
          <Actions
            isCollapsible={true}
            collapse={collapse}
            editMode={editMode ? editMode[partName] : false}
            toggleCollapse={toggleCollapse}
            toggleEditMode={(value) => toggleEditMode(partName, value)}
            onSubmit={() => onSubmit(partName, partData)}
            isLoading={isLoading || (partName in isCreatingPart && isCreatingPart[partName])}
          />
        </CardHeader>
        {lastUpdatedText(lastUpdated[partName])}
        <FulcrumDivider styleName='divider'/>
        <Spreadsheet 
          list={partData}
          editMode={editMode[partName]}
          formattingRanges={genFormattingRanges()}
          isLoading={isLoading || (partName in isCreatingPart && isCreatingPart[partName])}
          filters={true}
        />
      </Fragment>
    )
  }

  const cardRenderer = () => {
    if (T.translate(`containers.admin.partsLibrary.${props.partName}.title`) === 'Panel Settings') {
      return panelSettingsCardRenderer()
    } else {
      return defaultCardRenderer()
    }
  }
  
  return (
    <Card theme={styles}>
      {cardRenderer()}
    </Card>
  )
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)
const enhance = compose(
  withRouter,
  withConnect,
  withCollapse,
  withEditHandlers,
  withStyle
)
const PartsSection = enhance(SectionCard)

export default nest(Section, PartsSection)